<div
  #subtitleBox
  cdkDrag
  [cdkDragDisabled]="isResizing() || !enableEdit()"
  [cdkDragLockAxis]="hasHorizontalMargins() ? 'y' : null"
  [cdkDragBoundary]="dragBoundary()"
  class="subtitle-box"
  [class.edit-mode]="enableEdit()"
  [style.width.px]="scaledWidth()"
  [style.height.px]="scaledHeight()"
  (cdkDragStarted)="onDragStarted()"
  (cdkDragEnded)="onDragEnded($event)"
  [cdkDragFreeDragPosition]="scaledPosition()"
  [style.backgroundColor]="'transparent'"
  [style.border]="enableEdit() ? '1px solid rgba(0, 0, 0, 0.7)' : 'none'"
  [style.padding]="'0'"
  [style.overflow]="'hidden'"
  [style.will-change]="enableEdit() ? 'transform' : 'auto'">
  <div class="subtitle-container">
    <div class="subtitle-content" [appTextDirection]="transcriptLanguage()">
      @for (group of displayedMessageGroups(); track group.id) {
        <p
          [style.fontSize]="fontSize()"
          [style.lineHeight]="lineHeight() + 'px'"
          [@fadeAnimation]
          class="message-line">
          @for (message of group.messages; track message.documentID; let first = $first) {
            @if (!first) { {{ ' ' }} }
            <span
             class="subtitle-text"
             [class.has-background]="subtitleBoxSettings().overlay_color_opacity > 0"
             [style.backgroundColor]="overlayBackgroundColor()"
             [style.color]="fontColor()"
             [style.fontFamily]="fontFamily()"
             [style.lineHeight]="1.8"
             [style.textShadow]="textStrokeShadow()"
             appStableText
             [documentId]="message.documentID"
             [isFinal]="message.is_final">
            </span>
          }
        </p>
      }
    </div>
  </div>

  <!-- Resize Handle -->
  @if (enableEdit() && !hasFixedMargins()) {
    <div
      class="resize-handle"
      (mousedown)="onMouseDown($event); $event.stopPropagation()"></div>
  }
</div>

<!-- Hidden element for height calculation -->
<div #heightCalculator class="height-calculator" [style.visibility]="'hidden'">
  <div class="subtitle-content">
    @for (i of heightCalculatorLines(); track i) {
      <p
        [style.fontSize]="fontSize()"
        [style.lineHeight]="lineHeight() + 'px'"
        class="message-line">
        <span
          class="subtitle-text"
          [class.has-background]="subtitleBoxSettings().overlay_color_opacity > 0"
          [style.backgroundColor]="overlayBackgroundColor()"
          [style.color]="fontColor()"
          [style.fontFamily]="fontFamily()"
          [style.lineHeight]="1.8"
          [style.textShadow]="textStrokeShadow()">
          Sample Text Line {{ i }}
        </span>
      </p>
    }
  </div>
</div>

